import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IntercomService } from 'app/intercom/intercom.service';
import { FolderNavBarService } from 'app/layout/folder-navbar/folder-navbar.service';
import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-account-upgrade-modal',
  templateUrl: 'account-upgrade-modal.component.html',
  styleUrls: ['account-upgrade-modal.component.scss'],
})
export class AccountUpgradeModalComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() imageSrc: string;
  @Input() imageAlt: string;
  @Input() isCloseButtonVisible: boolean;

  canSwitchWorkspace = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly intercomService: IntercomService,
    public readonly activeModal: NgbActiveModal,
    private readonly folderNavbarService: FolderNavBarService,
    private readonly userService: UserService,
  ) {}

  ngOnInit(): void {
    this.setupCanSwitchWorkspace();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupCanSwitchWorkspace() {
    const userControllerMap = this.userService.getUserControllerMap();
    if (userControllerMap.isAdmin) {
      this.canSwitchWorkspace = true;
      return;
    }

    this.folderNavbarService
      .getUserCompanies()
      .pipe(takeUntil(this.destroy$))
      .subscribe((companies) => {
        this.canSwitchWorkspace = companies.length > 1;
      });
  }

  openLiveChat() {
    this.intercomService.open();
  }

  switchWorkspace() {
    this.activeModal.close();
  }
}
